import classNames from "classnames";
import { observer } from "mobx-react";
import React from "react";
import { intl } from "@fidget/common/i18n/TypedIntl";
import { useStore } from "../../../../../models";
import settingsStyles from "../../../../../styles/settings.css";
import { VerticalSeparator } from "../../../settingsForms/separators/verticalSeparator/verticalSeparator";
import { NewAgentGroupForm } from "../../types";
import { AdvisersAvatarList } from "../advisersAvatarList/advisersAvatarList";
import { AdvisersInput } from "../advisersInput/advisersInput";
import { AdviserGroupNameInput } from "../nameInput/adviserGroupNameInput";
import styles from "../styles.css";
import { staticConfig } from "@fidget/common/config/static-config";

interface Props {
  form: NewAgentGroupForm;
}

export const NewAgentGroupBox = observer(({ form }: Props) => {
  const { agentStore } = useStore();

  const advisers = agentStore.getByIds(form.$.advisers.$);

  return (
    <div className={settingsStyles.flex}>
      <div className={settingsStyles["flex-column"]}>
        <span className={classNames(settingsStyles["form-label-font"], styles["label-margin"])}>
          {intl.formatMessage("settings.adviserGroups.form.group")}
        </span>
        <AdviserGroupNameInput field={form.$.name} />
        <span
          className={classNames(
            settingsStyles["form-description-font"],
            styles["description-margin"]
          )}
        >
          {intl.formatMessage("settings.adviserGroups.form.group.description", {
            limit: staticConfig.agentGroupNameMaxCharacters
          })}
        </span>
      </div>
      <VerticalSeparator />
      <div className={settingsStyles["flex-column"]}>
        <span className={classNames(settingsStyles["form-label-font"], styles["label-margin"])}>
          {intl.formatMessage("settings.adviserGroups.form.advisers")}
        </span>
        <AdvisersInput
          onPicked={(adviserId) => form.$.advisers.reset([...form.$.advisers.$, adviserId])}
          ListComponent={
            advisers.length ? (
              <AdvisersAvatarList
                advisers={advisers}
                onDelete={(adviser) =>
                  form.$.advisers.reset(form.$.advisers.$.filter((id) => adviser.id !== id))
                }
              />
            ) : undefined
          }
          adviserIds={form.$.advisers.$}
          hasError={form.$.advisers.hasError}
          initialIsOpen
        />
      </div>
    </div>
  );
});
